// Plausible analytics for the GPS "Formulaires" AI-analysis teaser.
// Three thin wrappers around the shared `trackEvent`, each in its own try/catch
// so analytics can never break the UI. No backend, no waitlist — appetite only.
import { trackEvent } from './analytics.js';
import { safeNum } from './gpsFormUtils.js';

// Bucket the respondent volume defensively (null/NaN/'x' → '0-49').
export const respondentsBucket = (respondents) => {
  const n = safeNum(respondents);
  if (n >= 200) return '200+';
  if (n >= 50) return '50-199';
  return '0-49';
};

// Build the props shared by all three events: project label, client, role.
export const buildSharedProps = ({ project, currentUser } = {}) => ({
  project: project ?? null,
  client: currentUser?.client ?? null,
  role: currentUser?.isadmin || currentUser?.issuperadmin ? 'admin' : 'standard',
});

// Denominator (exposure) — once per selected question.
export const trackTeaserView = ({ project, currentUser, respondents } = {}) => {
  try {
    trackEvent('gps_form_ai_teaser_view', {
      props: { ...buildSharedProps({ project, currentUser }), respondentsBucket: respondentsBucket(respondents) },
    });
  } catch (e) {
    /* analytics must never break the UI */
  }
};

// Numerator (interest) — `cta` is 'notify' | 'interested'; carries the email for follow-up.
export const trackTeaserCtaClick = ({ project, currentUser, cta, respondents } = {}) => {
  try {
    trackEvent('form_ai_teaser_cta_click', {
      props: {
        ...buildSharedProps({ project, currentUser }),
        cta,
        email: currentUser?.email ?? null,
        respondentsBucket: respondentsBucket(respondents),
      },
    });
  } catch (e) {
    /* analytics must never break the UI */
  }
};

// Leading curiosity signal — the TextView "Voir l'Analyse IA ↓" link.
export const trackTeaserScroll = ({ project, currentUser } = {}) => {
  try {
    trackEvent('form_ai_teaser_scroll', { props: buildSharedProps({ project, currentUser }) });
  } catch (e) {
    /* analytics must never break the UI */
  }
};
